import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postMaintenance } from '../Api'

export default generateApiAction({
  baseType: Types.MAINTENANCES.POST,
  api: postMaintenance,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/maintenances/PostAction.js